import Repository from '../axios'
import {defaultPagination} from "../constants/config";
import staff from "../apis/staff";

const resource = "/supplier/raw_materials";
export default {

  createRawMaterial(payload) {
    return Repository.post(`${resource}`, payload)
  },
  createRawMaterialFromExisting(site, payload) {
    return Repository.put(`/supplier/site/raw_materials/${site}`, payload)
  },
  replicateRawMaterialFromExisting(raw_material_id, payload) {
    return Repository.post(`/supplier/raw_material/replicate/${raw_material_id}`, payload)
  },
  getRawMaterialStatus(id) {
    return Repository.get(`/supplier/raw_material/get-status/${id}`)
  },
  getRawMaterialDetails(id) {
    return Repository.get(`${resource}/${id}`)
  },
  updateRawMaterialDetails(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  },
  getRawMaterialsBySite(id) {
    return Repository.get(`${resource}?manufacturing_site_id=${id}`)
  },
  getRawMaterials(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/supplier/raw_material_list?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  submitRawMaterial(id) {
    return Repository.put(`/supplier/raw_material/${id}/submit`)
  },

  // getAllManufacturerSites(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
  //   return Repository.get(`${resource}/sites?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  // },

  getRawMaterialProductIdentity(id) {
    return Repository.get(`/supplier/raw_material/products/${id}`)
  },
  CreateRawMaterialProductIdentity(payload) {
    return Repository.post(`/supplier/raw_material/products`, payload)
  },
  UpdateRawMaterialProductIdentity(id, payload) {
    return Repository.put(`/supplier/raw_material/products/${id}`, payload)
  },

  getRawMaterialPCSParameters(id) {
    return Repository.get(`/supplier/raw_material/parameters/${id}`)
  },
  CreateRawMaterialPCSParameters(payload) {
    return Repository.post(`/supplier/raw_material/parameters`, payload)
  },
  UpdateRawMaterialPCSParameters(id, payload) {
    return Repository.put(`/supplier/raw_material/parameters/${id}`, payload)
  },

  getRawMaterialManufacturingProcess(id) {
    return Repository.get(`/supplier/raw_material/processes/${id}`)
  },
  CreateRawMaterialManufacturingProcess(payload) {
    return Repository.post(`/supplier/raw_material/processes`, payload)
  },
  UpdateRawMaterialManufacturingProcess(id, payload) {
    return Repository.put(`/supplier/raw_material/processes/${id}`, payload)
  },

  getRawMaterialProductAuthenticity(id) {
    return Repository.get(`/supplier/raw_material/authenticities/${id}`)
  },
  CreateRawMaterialProductAuthenticity(payload) {
    return Repository.post(`/supplier/raw_material/authenticities`, payload)
  },
  UpdateRawMaterialProductAuthenticity(id, payload) {
    return Repository.put(`/supplier/raw_material/authenticities/${id}`, payload)
  },

  getRawMaterialComposition(id) {
    return Repository.get(`/supplier/raw_material/compositions/${id}`)
  },
  CreateRawMaterialComposition(payload) {
    return Repository.post(`/supplier/raw_material/compositions`, payload)
  },
  UpdateRawMaterialComposition(id, payload) {
    return Repository.put(`/supplier/raw_material/compositions/${id}`, payload)
  },

  getRawMaterialAdditivePreservative(id) {
    return Repository.get(`/supplier/raw_material/add_pres/${id}`)
  },
  CreateRawMaterialAdditivePreservative(payload) {
    return Repository.post(`/supplier/raw_material/add_pres`, payload)
  },
  UpdateRawMaterialAdditivePreservative(id, payload) {
    return Repository.put(`/supplier/raw_material/add_pres/${id}`, payload)
  },

  getRawMaterialSolvent(id) {
    return Repository.get(`/supplier/raw_material/solvents/${id}`)
  },
  CreateRawMaterialSolvent(payload) {
    return Repository.post(`/supplier/raw_material/solvents`, payload)
  },
  UpdateRawMaterialSolvent(id, payload) {
    return Repository.put(`/supplier/raw_material/solvents/${id}`, payload)
  },

  getRawMaterialEnzymesCatalysts(id) {
    return Repository.get(`/supplier/raw_material/enz_cats/${id}`)
  },
  CreateRawMaterialEnzymesCatalysts(payload) {
    return Repository.post(`/supplier/raw_material/enz_cats`, payload)
  },
  UpdateRawMaterialEnzymesCatalysts(id, payload) {
    return Repository.put(`/supplier/raw_material/enz_cats/${id}`, payload)
  },

  getRawMaterialGeneticallyModifiedOrganisms(id) {
    return Repository.get(`/supplier/raw_material/gmos/${id}`)
  },
  CreateRawMaterialGeneticallyModifiedOrganisms(payload) {
    return Repository.post(`/supplier/raw_material/gmos`, payload)
  },
  UpdateRawMaterialGeneticallyModifiedOrganisms(id, payload) {
    return Repository.put(`/supplier/raw_material/gmos/${id}`, payload)
  },

  getRawMaterialAllergens(id) {
    return Repository.get(`/supplier/raw_material/allergens/${id}`)
  },
  CreateRawMaterialAllergens(payload) {
    return Repository.post(`/supplier/raw_material/allergens`, payload)
  },
  UpdateRawMaterialAllergens(id, payload) {
    return Repository.put(`/supplier/raw_material/allergens/${id}`, payload)
  },

  getRawMaterialBaps(id) {
    return Repository.get(`/supplier/raw_material/baps/${id}`)
  },
  CreateRawMaterialBaps(payload) {
    return Repository.post(`/supplier/raw_material/baps`, payload)
  },
  UpdateRawMaterialBaps(id, payload) {
    return Repository.put(`/supplier/raw_material/baps/${id}`, payload)
  },

  getRawMaterialDerivatives(id) {
    return Repository.get(`/supplier/raw_material/derivatives/${id}`)
  },
  CreateRawMaterialDerivatives(payload) {
    return Repository.post(`/supplier/raw_material/derivatives`, payload)
  },
  UpdateRawMaterialDerivatives(id, payload) {
    return Repository.put(`/supplier/raw_material/derivatives/${id}`, payload)
  },

  getRawMaterialAdditional(id) {
    return Repository.get(`/supplier/raw_material/add_infos/${id}`)
  },
  CreateRawMaterialAdditional(payload) {
    return Repository.post(`/supplier/raw_material/add_infos`, payload)
  },
  UpdateRawMaterialAdditional(id, payload) {
    return Repository.put(`/supplier/raw_material/add_infos/${id}`, payload)
  },

  getRawMaterialStorage(id) {
    return Repository.get(`/supplier/raw_material/storages/${id}`)
  },
  CreateRawMaterialStorage(payload) {
    return Repository.post(`/supplier/raw_material/storages`, payload)
  },
  UpdateRawMaterialStorage(id, payload) {
    return Repository.put(`/supplier/raw_material/storages/${id}`, payload)
  },

  getRawMaterialPackagingTransport(id) {
    return Repository.get(`/supplier/raw_material/pack_trans/${id}`)
  },
  CreateRawMaterialPackagingTransport(payload) {
    return Repository.post(`/supplier/raw_material/pack_trans`, payload)
  },
  UpdateRawMaterialPackagingTransport(id, payload) {
    return Repository.put(`/supplier/raw_material/pack_trans/${id}`, payload)
  },

  getRawMaterialDietarySuitabilityItem(id) {
    return Repository.get(`/supplier/raw_material/dietary_suitabilities/${id}`)
  },
  CreateRawMaterialDietarySuitabilityItem(payload) {
    return Repository.post(`/supplier/raw_material/dietary_suitabilities`, payload)
  },
  UpdateRawMaterialDietarySuitabilityItem(id, payload) {
    return Repository.put(`/supplier/raw_material/dietary_suitabilities/${id}`, payload)
  },

  getRawMaterialProductTreatments(id) {
    return Repository.get(`/supplier/raw_material/product_treatments/${id}`)
  },
  CreateRawMaterialProductTreatments(payload) {
    return Repository.post(`/supplier/raw_material/product_treatments`, payload)
  },
  UpdateRawMaterialProductTreatments(id, payload) {
    return Repository.put(`/supplier/raw_material/product_treatments/${id}`, payload)
  },

  getRawMaterialLegislative(id) {
    return Repository.get(`/supplier/raw_material/legislative_statuses/${id}`)
  },
  CreateRawMaterialLegislative(payload) {
    return Repository.post(`/supplier/raw_material/legislative_statuses`, payload)
  },
  UpdateRawMaterialLegislative(id, payload) {
    return Repository.put(`/supplier/raw_material/legislative_statuses/${id}`, payload)
  },

  getRawMaterialGlobalSuitability(id) {
    return Repository.get(`/supplier/raw_material/global_suitabilities/${id}`)
  },
  CreateRawMaterialGlobalSuitability(payload) {
    return Repository.post(`/supplier/raw_material/global_suitabilities`, payload)
  },
  UpdateRawMaterialGlobalSuitability(id, payload) {
    return Repository.put(`/supplier/raw_material/global_suitabilities/${id}`, payload)
  },

  getRawMaterialSupportingDocumentation(id) {
    return Repository.get(`/supplier/raw_material/supporting_documentations/${id}`)
  },
  CreateRawMaterialSupportingDocumentation(payload) {
    return Repository.post(`/supplier/raw_material/supporting_documentations`, payload)
  },
  UpdateRawMaterialSupportingDocumentation(id, payload) {
    return Repository.put(`/supplier/raw_material/supporting_documentations/${id}`, payload)
  },

  getRawMaterialContaminantsPesticides(id) {
    return Repository.get(`/supplier/raw_material/contaminant_pesticides/${id}`)
  },
  CreateRawMaterialContaminantsPesticides(payload) {
    return Repository.post(`/supplier/raw_material/contaminant_pesticides`, payload)
  },
  UpdateRawMaterialContaminantsPesticides(id, payload) {
    return Repository.put(`/supplier/raw_material/contaminant_pesticides/${id}`, payload)
  },

  getCurrencyList() {
    return Repository.get('/supplier/currencies')
  },
  getUnitList() {
    return Repository.get('/supplier/units')
  },

  getRawMaterialCommercialDetails(id) {
    return Repository.get(`/supplier/raw_material/commercials/${id}`)
  },
  CreateRawMaterialCommercialDetails(payload) {
    return Repository.post(`/supplier/raw_material/commercials`, payload)
  },
  UpdateRawMaterialCommercialDetails (id, payload) {
    return Repository.put(`/supplier/raw_material/commercials/${id}`, payload)
  },

  // price change requests
  getListOfPriceChange(raw_material_id) {
    return Repository.get(`/supplier/raw_material/price_change_requests?raw_material_id=${raw_material_id}`)
  },
  createPriceChangeRequest(payload) {
    return Repository.post(`/supplier/raw_material/price_change_requests`, payload)
  },
  getPriceChangeRequestDetails(id) {
    return Repository.get(`/supplier/raw_material/price_change_requests/${id}`)
  }
}
